{
  "name": "12-Ptolemaic (pure fifths and thirds: 5-Limit JI)",
  "description": "12-tone 5-Limit Rational Intonation scale, derived from harmonic partial row intervals up to a prime limit of 5. The three major and minor triads on F, C, and G are tuned pure, as 4:5:6 or 10:12:15 ratios. The fifth between D (from the triad G major) and A (from the triad F major) is 27:40, one Syntonic Comma (81/80) smaller than a pure 2:3 ratio.",
  "scale": [
    "16/15",
    "9/8",
    "6/5",
    "5/4",
    "4/3",
    "45/32",
    "3/2",
    "8/5",
    "5/3",
    "9/5",
    "15/8",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-JI-5L_Ptolemy",
  "built_in_group": "12 Note Scales",
  "key_labels": "note_names",
  "note_names": ["C", "D", "D", "E", "E", "F", "F", "G", "A", "A", "B", "B"],
  "note_colors": [
    "#ffffff",
    "#dee2da",
    "#ffffff",
    "#dee2da",
    "#fffae5",
    "#ffffff",
    "#fffae5",
    "#ffffff",
    "#dee2da",
    "#fffae5",
    "#dee2da",
    "#fffae5"
  ],
  "equivSteps": 12,
  "fundamental": 260.740741,
  "reference_degree": 0,
  "center_degree": 0,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
